import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { UNSAFE_expValNoExposure } from '@confluence/feature-experiments';

import { getAllRecentInitialVars } from './recentQueryConstants.ts';
import RecentContentMenuQuery, {
	type RecentContentMenuQuery$data,
	type RecentContentMenuQuery$variables,
} from './queries/__generated__/RecentContentMenuQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadRecentContentMenu(cloudId: any): Promise<{
	data: RecentContentMenuQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return queryAgg<RecentContentMenuQuery$data, RecentContentMenuQuery$variables>({
		query: RecentContentMenuQuery,
		// Runs on hover: read the experiment without exposure, so users who never open Recent aren't
		// counted. The dialog logs the exposure when it renders.
		variables: getAllRecentInitialVars(
			cloudId,
			UNSAFE_expValNoExposure('confluence_recent_3p_activities', 'isEnabled', false),
		),
		fetchPolicy: 'network-only',
	});
}
